import {QuizQuestionModelType} from "../QuizQuestionModel";
import {queryQuizServerGqlApi} from "../../../graphql/quiz/queryQuizServerGqlApi";

import {deleteQuizQuestion as deleteQuizQuestionGQL} from "../../../graphql/quiz/mutations";
import {queryGqlApi} from "../../../graphql/queryGqlApi";
import {IDataClientService} from "../../../platform/services/data/DataClientService";
import {IAuthService} from "../../../platform/services/auth/AuthService";


export const deleteQuizQuestion = async (
    dataClientService: IDataClientService,
    authService: IAuthService,
    quizQuestion: QuizQuestionModelType
) => {
    if (!quizQuestion.isNew) {
        return await deleteQuizQuestionById(dataClientService, authService, quizQuestion.id);
    }
    return quizQuestion;
}

export const deleteQuizQuestionById = async (
    dataClientService: IDataClientService,
    authService: IAuthService,
    quizQuestionId: string
) => {
    const deletedValue = await queryGqlApi(
        deleteQuizQuestionGQL,
        {
            input: {
                id: quizQuestionId,
            }
        },
        dataClientService,
        authService,
        'pgServer'
    );
    return deletedValue as unknown as QuizQuestionModelType;
}
